$('.in-index .storeFeed').slick({
 slidesToShow: 1,
 slidesToScroll: 1,
 centerMode: false,
 autoplay: false,
 autoplaySpeed: 5000,
 dots: false,
 arrows: true,
 infinite: false,
 adaptiveHeight: false,
});